/**
 * In-cave music (05 §3), off by default as in 1984: a quiet A-minor groove, 112 BPM, 8 bars
 * (17 s) looping. Mostly bass, hat and two chord stabs a bar; the lead only answers in bars 3-4
 * and 7-8, so there is room for the boulders.
 */

import { SPARSE, STABS } from './grooves';
import type { Song } from './types';

export const CAVE: Song = {
  bpm: 112,
  loop: true,
  bassFloor: 33,
  arpFloor: 57,
  mix: { lead: 0.12, arp: 0.06, bass: 0.2, drum: 0.16 },
  order: ['groove'],
  patterns: {
    groove: {
      chords: 'Am | Am | F | G | Am | Am | Dm | E',
      lead: `
        - . . . . . . . . . . . . . . . |
        - . . . . . . . . . . . . . . . |
        C5 . . . . . A4 . . . E5 . . . . . |
        D5 . . . . . . . B4 . . . . . - . |
        - . . . . . . . . . . . . . . . |
        - . . . . . . . . . . . . . . . |
        F5 . . . . . E5 . . . D5 . . . . . |
        E5 . . . . . . . G#4 . . . . . - .`,
      bass: { groove: SPARSE },
      arp: STABS,
    },
  },
};
